import { render } from "./TaskComments.vue?vue&type=template&id=399a7ef8&scoped=true"
import script from "./TaskComments.vue?vue&type=script&lang=js"
export * from "./TaskComments.vue?vue&type=script&lang=js"

import "./TaskComments.vue?vue&type=style&index=0&id=399a7ef8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-399a7ef8"]])

export default __exports__